import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimoniosSection() {
  const testimonios = ['https://cdn.magicpatterns.com/uploads/aEYYcaPDbv9dYDCGU7uQic/WhatsApp_Image_2026-03-16_at_17.42.38.jpg', 'https://cdn.magicpatterns.com/uploads/kjA3RZmwB19uwaErt6wzNZ/WhatsApp_Image_2026-03-16_at_19.18.23.jpg', 'https://cdn.magicpatterns.com/uploads/5w2a26R52GBeQeqb1V4uVq/WhatsApp_Image_2026-03-16_at_19.29.58.jpg', 'https://cdn.magicpatterns.com/uploads/jtgR2ffQ8adKwkJKwryQZQ/WhatsApp_Image_2026-03-16_at_19.30.05.jpg'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-210">
      <div className="max-w-6xl mx-auto" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-16" data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-black mb-6" data-id="element-213">
            Lo que dicen quienes ya están adentro
          </h2>
          <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-214"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-215">
          {testimonios.map((imgSrc, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.25,
          delay: index * 0.08
        }} className="bg-white rounded-2xl overflow-hidden shadow-md border-4 border-white ring-1 ring-black/5 hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-216">
              <div className="relative w-full h-[400px] sm:h-[450px] lg:h-[500px]" data-id="element-217">
                <img src={imgSrc} alt={`Testimonio de cliente ${index + 1}`} className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" data-id="element-218" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.15
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-219">
          <a href="#" className="w-full sm:w-auto bg-brand-black text-white font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:bg-gray-800 hover:scale-[1.03] transition-all text-center" data-id="element-220">
            Yo también quiero esto
          </a>
          <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-brand-black font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-221">
            Hablar por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}